import { membershipApi } from 'app/src/services/welfareportal'
import { useWebAppContext, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

export function JoinButton(props?: { className?: string }) {
  const { t } = useTranslation('landing')

  const context = useWebAppContext()
  const navigate = useWelfarePortalNavigate()
  return (
    context.userInfo.welfareCampaign.mustJoin &&
    membershipApi.getPhaseAndDeadline(context.userInfo.welfareCampaign).phase == 'join' && (
      <Button
        rounded
        label={t('Landing.Join.ButtonLabel')}
        className={props?.className ?? 'mx-5 my-5'}
        onClick={navigate.goToUserJoin}
      ></Button>
    )
  )
}
